import { useSelector } from "react-redux";

const { REACT_APP_SENDBIRD_APP_ID } = process.env;
const useChatInit = () => {
  const appId = REACT_APP_SENDBIRD_APP_ID;
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const accessToken = useSelector(
    (state) => state.connectChatServer.accessToken
  );

  const channelUrl = useSelector((state) => state.connectChatServer.channelUrl);
  const startingPoint = useSelector(
    (state) => state.connectChatServer.startTime
  );
  const ticketId = useSelector((state) => state.connectChatServer.ticketId);
  return [appId, userId, accessToken, channelUrl, startingPoint, ticketId];
};

export default useChatInit;
